<template>
  <div>
    <v-navigation-drawer
      :expand-on-hover="miniNav && $vuetify.breakpoint.lgAndUp"
      :mini-variant="miniNav && $vuetify.breakpoint.lgAndUp"
      color="white"
      app
      overflow
      v-model="drawer"
      :clipped="clipped"
      v-if="currentUserData"
    >
      <v-list dense>
        <!-- <v-list-item :to="'/'">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->
        <v-list-item :to="'/'">
          <v-list-item-action>
            <v-icon>mdi-grid</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/stock'">
          <v-list-item-action>
            <v-icon>mdi-package-variant-closed</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Stock</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/promotions/banner'">
          <v-list-item-action>
            <v-icon>mdi-bullhorn-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Promotions</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/promotions/featured'">
          <v-list-item-action>
            <v-icon>mdi-view-carousel-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Featured Slider</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/magazines'">
          <v-list-item-action>
            <v-icon>mdi-book-open-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Magazines</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/industrialMagazines'">
          <v-list-item-action>
            <v-icon>mdi-book-open-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Industrial Magazines</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="'/locations'">
          <v-list-item-action>
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Locations</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-if="$vuetify.breakpoint.lgAndUp" v-slot:append>
        <div class="pl-3 mb-4">
          <v-switch
            v-model="miniNav"
            @change="updateView"
            label="Mini Nav"
          ></v-switch>
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar app color="primary" dark :clipped-left="true">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
        @click="
          () => {
            if ($route.path !== '/') {
              $router.push('/');
            }
          }
        "
        v-clickable
        >Telfers</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-menu
        v-if="currentUser"
        v-model="userMenu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="transparent"
            text
            dark
            v-bind="attrs"
            v-on="on"
            class="pa-0"
          >
            <avatar
              :size="35"
              color="white"
              :username="
                currentUser.idToken.payload.username == null
                  ? currentUser.idToken.payload.email
                  : currentUser.idToken.payload.username
              "
            ></avatar>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <avatar
                  :size="35"
                  color="white"
                  :username="
                    currentUser.idToken.payload.username == null
                      ? currentUser.idToken.payload.email
                      : currentUser.idToken.payload.username
                  "
                ></avatar>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>
                  {{ currentUser.idToken.payload.username }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ currentUser.idToken.payload.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list>
            <v-list-item>
              <v-btn
                block
                dark
                color="primary"
                v-if="currentUser"
                @click="logout()"
              >
                <v-icon left>mdi-lock-open</v-icon>Logout
              </v-btn>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import Avatar from "vue-avatar";

  export default {
    computed: {
      ...mapGetters([
        "siteData",
        "currentUser",
        "currentUserData",
        "navigationDrawer",
      ]),
    },
    data: () => ({
      userMenu: false,
      hints: false,
      message: "",
      fav: false,
      drawer: false,
      clipped: true,
      miniNav: false,
      drawerRoutes: {},
      linkedToGoogle: false,
    }),
    components: {
      Avatar,
    },
    beforeCreate() {},
    mounted() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.drawer = false;
        this.$store.dispatch("setNavigationDrawerState", false);
      } else {
        this.drawer = this.navigationDrawer;
      }
    },
    methods: {
      changeNavigationDrawer() {
        this.$store.dispatch("setNavigationDrawerState", !this.drawer);
        this.drawer = !this.drawer;
      },
      updateView() {
        if (this.miniNav == true) {
          this.drawer = false;
          var self = this;
          setTimeout(function () {
            self.drawer = true;
          }, 300);
        }
      },
      logout() {
        this.$store.dispatch("logout");
      },
    },
  };
</script>
